import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,

    ClearParentsOkrObjective,
    DeleteOkrKeyResult,

    setOkrKeyResultShowConfirmDelete,
    setOkrObjectiveReloadList,
} from "client/store"
import {
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    Button,
    SpinnerIcon,
} from "client/components"

const ConfirmDelete = () => {
    const activeKeyResult = useSelector((state: StoreType) => state.okrKeyResult.active)
    const showConfirm = useSelector((state: StoreType) => state.okrKeyResult.showConfirmDelete)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    const onCancel = () => {
        dispatch(setOkrKeyResultShowConfirmDelete(false))
    }

    const onConfirm = () => {
        setDeleteState(PENDING)
        // clear parents
        ClearParentsOkrObjective({
            sessionId: activeKeyResult.sessionId,
            objectiveId: null,
            keyResultId: activeKeyResult.id,
        }).then(() => {
            DeleteOkrKeyResult(activeKeyResult.id, activeKeyResult.objectiveId, activeKeyResult.sessionId).then(() => {
                setDeleteState(IDLE)
                dispatch(setOkrKeyResultShowConfirmDelete(false))

                // reload main objective list
                dispatch(setOkrObjectiveReloadList(false))
                setTimeout(() => {
                    dispatch(setOkrObjectiveReloadList(true))
                }, 0)
            })
        })
    }

    return (
        <ConfirmWrapper show={showConfirm} onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{activeKeyResult && activeKeyResult.title}</ConfirmTitle>
                <ConfirmDescription>{lang.deleteKeyResultConfirm}</ConfirmDescription>

                <ConfirmBottom>
                    <Button row onClick={onCancel}>{lang.cancel}</Button>
                    <Button variant="success" row onClick={onConfirm}>
                        {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDelete
